// extracted by mini-css-extract-plugin
export var content = "EcbCalculator-module--content--6bfba";
export var error = "EcbCalculator-module--error--860e7";
export var exchangeCalculator = "EcbCalculator-module--exchange-calculator--0d7b1";
export var exchangeCalculatorInner = "EcbCalculator-module--exchange-calculator-inner--5dc7f";
export var fees = "EcbCalculator-module--fees--8108b";
export var form = "EcbCalculator-module--form--2bcbf";
export var formBody = "EcbCalculator-module--formBody--5e320";
export var intro = "EcbCalculator-module--intro--6e586";
export var lgBreak = "1200";
export var mdBreak = "992";
export var results = "EcbCalculator-module--results--dc4e2";
export var resultsInner = "EcbCalculator-module--results-inner--5ae36";
export var smBreak = "768";
export var title = "EcbCalculator-module--title--1a2f5";
export var total = "EcbCalculator-module--total--42659";
export var xsBreak = "480";